'use client';

import { useEffect, useRef } from 'react';
import { usePathname } from 'next/navigation';

import { openLoginModal, EModalType } from '@/components/login-modal';
import { useAuthState } from '@/store/user/selectors';
import { frequencyControl } from '@/utils/device/frequency-control';

function isReaderRoute(path: string): boolean {
    return path === '/reader' || path.startsWith('/reader/');
}

/**
 * 离开 `/reader` 进入其它站内路由时，按频控弹出登录引导。
 * `login_source === 2`（账号登录）不弹；游客等仍可弹。
 */
export default function ReaderExitLoginPrompt(): null {
    const pathname = usePathname();
    const prevPathRef = useRef<string | null>(null);
    const { isLogin, loginSource, userId } = useAuthState();

    useEffect(() => {
        const prev = prevPathRef.current;
        prevPathRef.current = pathname;

        if (prev === null) {
            return;
        }

        const wasReader = isReaderRoute(prev);
        const isReader = isReaderRoute(pathname);

        /** 账号登录用户不再弹出（login_source === 2） */
        if (!wasReader || isReader || (isLogin && loginSource === 2)) {
            return;
        }

        frequencyControl(
            'reader_exit_login_modal_show',
            () => {
                openLoginModal({ type: EModalType.ReaderLogin });
            },
            {
                bucketKey: () => userId ?? '',
                minCalendarDaysBetweenPrompts: 2,
            }
        ).catch(() => {});
    }, [pathname, isLogin, loginSource, userId]);

    return null;
}
